import { useCallback } from "react";
import { UseFormSetValue } from "react-hook-form";
import { usePutChemicalData } from "../../../../api/chemical";
import { errorView, successMessage } from "../../../../helpers/ErrorHandler";

export interface ToggleChemicalTransportParams {
  enabled: boolean;
  recordId: string;
  fieldPrefix: string;
  chemicalName: string;
  chemicalType: string | number | undefined;
  amount: string;
}

interface UseChemicalTransportToggleOptions {
  setValue: UseFormSetValue<any>;
  type: string;
  supplierDataHandle?: boolean;
}

export const useChemicalTransportToggle = ({
  setValue,
  type,
  supplierDataHandle = false
}: UseChemicalTransportToggleOptions) => {
  const { mutate: updateChemical } = usePutChemicalData();

  const toggleTransportation = useCallback(
    ({
      enabled,
      recordId,
      fieldPrefix,
      chemicalName,
      chemicalType,
      amount
    }: ToggleChemicalTransportParams): void => {
      if (!recordId) {
        errorView("Chemical ID is missing");
        return;
      }

      setValue(`${fieldPrefix}.isTransportationDetailsAvailable`, enabled);

      const updatePayload = {
        chemicalId: recordId,
        type,
        supplierDataHandle,
        chemicalData: {
          chemicalName,
          chemicalType: Number(chemicalType || 1),
          amount: String(amount),
          transportationTypes: [],
          isTransportationDetailsAvailable: enabled
        }
      };

      updateChemical(updatePayload, {
        onSuccess: () => {
          successMessage(
            enabled
              ? "Transportation enabled successfully"
              : "Transportation disabled successfully"
          );
        },
        onError: (error: any) => {
          setValue(`${fieldPrefix}.isTransportationDetailsAvailable`, !enabled);
          errorView(error?.msg || "Failed to update chemical");
        }
      });
    },
    [setValue, type, supplierDataHandle, updateChemical]
  );

  return { toggleTransportation };
};
